// main.js
import { createApp } from "vue";
import App from "./App.vue";
import createStore from "./store";
import createRouter from "./router";
import { createHead } from "@unhead/vue";
import { getClientApi } from "./apis/Api";

// Jangan gunakan vue-easy-lightbox di sini.
// import VueEasyLightbox from "vue-easy-lightbox";

const store = createStore();
const router = createRouter();
const head = createHead();

const app = createApp(App);

app.config.globalProperties.$api = getClientApi();
app.provide('api', app.config.globalProperties.$api); // optional: untuk inject()

app.use(store);
app.use(router);
app.use(head);

if (window && window.__INITIAL_STATE__) {
    store.state.value = window.__INITIAL_STATE__;
}

app.mount("#app");


// === FIX: Matikan "tap interception" oleh overlay tersembunyi di mobile ===
// Prinsip: bila ada elemen fixed full-screen dengan z-index tinggi yang sudah
// hidden (display:none | visibility:hidden | opacity:0), paksa pointer-events:none
// agar tidak lagi menangkap tap di bawahnya.

(function () {
    const isHidden = (el, cs) =>
        cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0';

    const isFullscreenFixed = (el, cs, vw, vh) => {
        if (cs.position !== 'fixed') return false;
        // ambil ukuran aktual
        const r = el.getBoundingClientRect();
        const coversW = r.width >= vw * 0.9;
        const coversH = r.height >= vh * 0.9;
        const nearTop = r.top <= vh * 0.1;
        const nearLeft = r.left <= vw * 0.1;
        // z-index minimal 1 (hindari elemen fixed dekoratif kecil)
        const zi = parseInt(cs.zIndex || '0', 10);
        return zi >= 1 && coversW && coversH && nearTop && nearLeft;
    };

    const disableHiddenFullscreenOverlays = () => {
        const vw = window.innerWidth || document.documentElement.clientWidth;
        const vh = window.innerHeight || document.documentElement.clientHeight;

        // Batasi pencarian: hanya kandidat berposisi fixed
        // (querySelectorAll lebih hemat dibanding iterasi semua node)
        const candidates = document.querySelectorAll('body *');
        for (const el of candidates) {
            const cs = getComputedStyle(el);
            if (!isFullscreenFixed(el, cs, vw, vh)) continue;

            // Jika overlay terlihat, pastikan pointer-events kembali normal;
            // Jika tersembunyi, matikan supaya tidak intercept tap.
            if (isHidden(el, cs)) {
                if (el.style.pointerEvents !== 'none') el.style.pointerEvents = 'none';
            } else {
                if (el.style.pointerEvents === 'none') el.style.pointerEvents = '';
            }
        }
    };

    // Jalankan saat awal load + setiap perubahan layout umum.
    const run = () => setTimeout(disableHiddenFullscreenOverlays, 0);
    run();
    document.addEventListener('scroll', run, { passive: true });
    window.addEventListener('resize', run);
    document.addEventListener('visibilitychange', run);

    // Banyak UI framework memodifikasi DOM setelah tick render:
    // jalankan juga setelah event pointer/touch untuk cepat sinkron.
    ['pointerup', 'touchend', 'transitionend', 'animationend'].forEach(ev =>
        document.addEventListener(ev, run, { passive: true })
    );
})();

